// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Intro_content__zmWMR {
  text-align: center;
}
.Intro_content__zmWMR button {
  float: none;
}

.Intro_popup__yNtFZ {
  width: 430px;
  max-width: 90vw;
  position: absolute;
  z-index: 2;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background: #FFF;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
}
.Intro_popup__yNtFZ button {
  width: 100%;
  margin: 0;
  float: none;
  border: 1px solid #1414ff;
  border-radius: 8px;
}
.Intro_popup__yNtFZ button:first-of-type {
  color: #FFF;
  background-color: #1414ff;
  margin-top: 27px;
}
.Intro_popup__yNtFZ button:last-of-type {
  color: #1414ff;
  background-color: #FFF;
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Intro/Intro.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;AAKJ;AAHI;EACI,WAAA;AAKR;;AADA;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAIJ;AAFI;EACI,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAIR;AAFQ;EACI,WAAA;EACA,yBC5BD;ED6BC,gBAAA;AAIZ;AAFQ;EACI,cChCD;EDiCC,sBAAA;EACA,gBAAA;AAIZ","sourcesContent":["@use 'styles/colors.scss';\n\n.content{\n    text-align: center;\n\n    button{\n        float: none;\n    }\n}\n\n.popup{\n    width: 430px;\n    max-width: 90vw;\n    position: absolute;\n    z-index: 2;\n    top: 50vh;\n    left: 50vw;\n    transform: translate(-50%, -50%);\n    background: #FFF;\n    border-radius: 12px;\n    padding: 32px;\n    text-align: center;\n\n    button{\n        width: 100%;\n        margin: 0;\n        float: none;\n        border: 1px solid colors.$primary5;\n        border-radius: 8px;\n\n        &:first-of-type{\n            color: #FFF;\n            background-color: colors.$primary5;\n            margin-top: 27px;\n        }\n        &:last-of-type{\n            color: colors.$primary5;\n            background-color: #FFF;\n            margin-top: 12px;\n        }\n    }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"content": `Intro_content__zmWMR`,
	"popup": `Intro_popup__yNtFZ`
};
export default ___CSS_LOADER_EXPORT___;
